import React, {useEffect, useState} from 'react';
import PlanTable from "../../../../components/UI/table/optimization/plans/PlanTable";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import PlanService from "../../../../API/orders/optimization/organization/PlanService";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {PlansTableFilterData} from "../../../../data/FilterTables/PlansTableFilterData";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {planStateStatuses} from "../../../../data/PlanState";

const Plans = () => {
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [statusList, setStatusList] = useState([])
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        PlanService.getAllNotArchive().then(function (response) {
            let data = response.data;
            setStatusList(OrderUtil.getListFieldByEnum(data, 'planState', planStateStatuses));
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/plans`, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, PlansTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [PlansTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/plans`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/plans`]?.pageSize
        const searchQuery = pagesData[`organization/plans`]?.searchQuery

        return {searchQuery, pageSize}
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Планы"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Заказы", href: "/organization/orders"}
                ]}/>

            <PlanTable
                data={data}
                setData={setData}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
                globalFilter={globalFilter}
                filteredData={filteredData}
                handleSearchQuery={handleSearchQuery}
                columnsFilter={columnsFilter}
                statusList={statusList}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default Plans;